module.exports = __webpack_public_path__ + "img/six-bg.9f604048.svg";